import * as SliderPrimitive from "@radix-ui/react-slider"
import type { ComponentProps } from "react"
import { cn } from "@/lib/utils.js"

/**
 * The filled track leaves the accent for the risk family as the value reaches
 * the maximum — because for a rule weight the maximum *is* the block
 * threshold, so a slider at the end means "this rule alone blocks".
 */
export function Slider({
  className,
  atRisk = false,
  "aria-label": label,
  ...props
}: ComponentProps<typeof SliderPrimitive.Root> & { atRisk?: boolean }) {
  return (
    <SliderPrimitive.Root
      className={cn("relative flex h-5 w-full touch-none select-none items-center", className)}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-muted">
        <SliderPrimitive.Range
          className={cn("absolute h-full", atRisk ? "bg-critical" : "bg-iris")}
        />
      </SliderPrimitive.Track>
      {/*
       * The name goes on the thumb, not on the root: the thumb is what carries
       * `role="slider"`, the value and the keyboard, so a label on the wrapper
       * left the actual control unnamed.
       */}
      <SliderPrimitive.Thumb
        aria-label={label}
        className={cn(
          "block size-4 rounded-full border-2 bg-background shadow-xs transition-colors",
          atRisk ? "border-critical" : "border-iris",
        )}
      />
    </SliderPrimitive.Root>
  )
}
